import { render, staticRenderFns } from "./SingleNFT.vue?vue&type=template&id=7cd61dc9&scoped=true&"
import script from "./SingleNFT.vue?vue&type=script&lang=js&"
export * from "./SingleNFT.vue?vue&type=script&lang=js&"
import style0 from "./SingleNFT.vue?vue&type=style&index=0&id=7cd61dc9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd61dc9",
  null
  
)

export default component.exports